module.exports = __webpack_public_path__ + "static/assets/1a2ee8eee0de21faef0d378b2fb9b0b2.svg";